module.exports = __webpack_public_path__ + "static/media/pandas.a8eeb25d.png";